import React from 'react'

export default function LoginIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
            <path d="M5.6001 4.37993C5.80676 1.97998 7.04007 1 9.74002 1H9.82668C12.8066 1 13.9999 2.19331 13.9999 5.17325V9.51981C13.9999 12.4997 12.8066 13.6931 9.82668 13.6931H9.74002C7.06007 13.6931 5.82676 12.7264 5.60676 10.3665" stroke="#292D32" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M1 7.33971H9.58649" stroke="black" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M8.1001 5.10667L10.3334 7.33997L8.1001 9.57326" stroke="black" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    )
}
